import { BaseComponent } from '../../base/base.component';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParagraphData } from '../../../shared/public-api';

@Component({
  selector: 'admin-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
  imports: [CommonModule],
})
export class ParagraphComponent extends BaseComponent<ParagraphData> implements OnInit {
  text = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.text = this.data.text;
  }
}
